import { render, staticRenderFns } from "./TransferSummary.vue?vue&type=template&id=9b29caca"
import script from "./TransferSummary.vue?vue&type=script&lang=js"
export * from "./TransferSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports